export const state = () => ({
  isEditingUserDetails: false,
  isEditingFiscalData: false,
});

const getters = {
  isEditingUserDetails: (state) => state.isEditingUserDetails,
  isEditingFiscalData: (state) => state.isEditingFiscalData,
};

const mutations = {
  setIsEditingUserDetails(state, value) {
    state.isEditingUserDetails = value;
  },
  setIsEditingFiscalData(state, value) {
    state.isEditingFiscalData = value;
  },
};
const actions = {};

const namespaced = true;

export default {
  state,
  mutations,
  getters,
  actions,
  namespaced,
};
